<template>
  <Navbar />
  <div id="app" class="pt-16"> <!-- Added top padding to avoid overlap with the navbar -->
    <router-view></router-view>
  </div>
  <Footer />
</template>

<script>
import Footer from './components/Footer.vue';
import Navbar from './components/Navbar.vue';

export default {
  name: 'App',
  components: {
    Navbar,
    Footer
  }
};
</script>

<style>
/* Any global styles can go here */
</style>
